<template>
  <PanePromise
    id="eventDetailsPane"
    ref="PanePromiseREF"
    fit-content
    disabled
  >
    <LayoutBase
      v-if="event"
      gap="20"
    >
      <div class="header">
        <div class="name">
          {{ pet?.payload?.name }}
        </div>
        <div class="breed">
          {{ pet?.payload?.breed }}
        </div>
      </div>
      <ItemBase>
        {{ event.title }}
      </ItemBase>
      <ItemBase>
        {{ formattedDate }}
      </ItemBase>
      <ItemBase v-if="!event.all_day">
        {{ formattedTime }}
      </ItemBase>
      <ItemBase v-else>
        {{ t('calendarView.allDay') }}
      </ItemBase>
      <ButtonBase @click="edit">
        {{ t('common.edit') }}
      </ButtonBase>
      <ButtonBase
        variant="text"
        @click="hide"
      >
        {{ t('common.close') }}
      </ButtonBase>
    </LayoutBase>
  </PanePromise>
</template>

<script setup>
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { LayoutBase } from '@/components/Layouts'
import { ButtonBase, ItemBase, PanePromise } from '@/UI'

const { t } = useI18n()
const router = useRouter()

const PanePromiseREF = ref()
const event = ref(null)
const pet = ref(null)

const formattedDate = computed(() => event.value
  ? new Date(event.value.date).toLocaleDateString('ru-RU', { day: 'numeric', month: 'long', year: 'numeric' })
  : '')

const formattedTime = computed(() => {
  if (!event.value) {return ''}
  const date = new Date(event.value.date)
  return `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`
})

const open = async (payload) => {
  event.value = payload.event
  pet.value = payload.pet
  await PanePromiseREF.value.open()
}

const hide = () => {
  PanePromiseREF.value.close()
}

const edit = () => {
  PanePromiseREF.value.close()
  router.push(`/events/${event.value.id}/edit`)
}

defineExpose({
  openModal: open,
})
</script>

<style scoped lang="scss">
.header {
  text-align: center;
}

.name {
  font-weight: 700;
  font-size: 20px;
}

.breed {
  color: #6B7090;
  font-size: 14px;
}
</style>
